<div class="flex items-center" mat-dialog-title>
  <h2 class="headline m-0 flex-auto">
    {{ "Trademark Artwork" }}
  </h2>

  <button
    class="text-secondary"
    mat-dialog-close
    mat-icon-button
    type="button"
    aria-label="Close Dialog">
    <mat-icon svgIcon="mat:close"></mat-icon>
  </button>
</div>

<mat-divider class="text-border"></mat-divider>
<mat-dialog-content class="p-6">
  <div class="flex flex-row justify-start w-80 my-6">
    <!-- <h2 class="text-lg font-semibold text-[#1e293b]">
      {{ "User Guidelines" }}
    </h2> -->

    <a
      class="block font-medium text-blue-600 underline dark:text-blue-500 hover:no-underline"
      href="https://s3.us-west-2.amazonaws.com/cdn.fluidquality.com/staging/ebmSeJeaH2.txt"
      >User Guidelines</a
    >
  </div>
  <div class="flex flex-col w-full" *ngFor="let item of images">
    <ng-container *ngIf="item.isImage">
      <div>Type : {{ item?.type | uppercase }}</div>
      <img
        [src]="item?.file"
        alt="Image"
        class="h-64 w-full object-contain mx-auto my-4"
        (error)="handleImageError($event)" />
    </ng-container>
  </div>
  <!-- commented the readme note for client requirement -->
  <!-- <div class="flex flex-col justify-start gap-4">
        <h2 class="text-lg font-semibold  text-[#1e293b]">Readme</h2>
        <p class="text-start ">{{tradeMarkReadme}}</p>
    </div> -->
</mat-dialog-content>

<mat-dialog-actions></mat-dialog-actions>
